import { atom } from "recoil";
import { Preferito } from "../models/ServiceDescriptor";
import logColors from "../utils/logColors";

type ContextDialogType = {
    show: boolean,
    preferito?: Preferito,
    onSetContextPreferito?: (contesto: string) => void
}

export const contextDialogAtom = atom<ContextDialogType>({
    key: 'contextDialogAtom',
    default: {
        show: false
    }, 
    effects: [
        ({onSet}) => {
            onSet((newOpen, oldOpen) => {
                console.log(`%copenDialogAtom: ${newOpen.show}`, logColors.magenta12, oldOpen)
            })
        }
    ]
})
